import React, { useState, useCallback } from "react";
import classNames from "classnames";
import { graphql, useStaticQuery } from "gatsby";
import { useIntl, FormattedMessage } from "gatsby-plugin-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import TextField from "components/TextField";
import { Index } from "elasticlunr";
import debounce from "lodash.debounce";

const classes = {
  searchIcon:
    "absolute text-gray-700 center-absolute-y rtl:right-0 rtl:left-auto ltr:left-0 ltr:right-auto ltr:ml-6 rtl:mr-6 top-0",

  closeIcon:
    "absolute cursor-pointer text-gray-600 center-absolute-y rtl:left-0 ltr:right-0 rtl:right-auto ltr:left-auto ltr:mr-6 rtl:ml-6 top-0",
};

const Search = ({ className, onSearchClose, closeIcon = true, ...props }) => {
  const { formatMessage } = useIntl();
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);

  const data = useStaticQuery(graphql`
    query SearchIndexQuery {
      siteSearchIndex {
        index
      }
    }
  `);

  const handleSearch = useCallback(
    value => {
      const index = Index.load(data.siteSearchIndex.index);

      setQuery(value);

      debounce(() => {
        setResults(
          index
            .search(value, {})
            // Map over each ID and return the full document
            .map(({ ref }) => index.documentStore.getDoc(ref))
        );
      }, 450);
    },
    [data]
  );

  return (
    <div
      className={classNames(
        "relative search-bar ltr:ml-auto ltr:mr-6",
        className
      )}
      {...props}
    >
      <div className="container">
        <form>
          <div
            // style={{ boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.08)" }}
            className="search-bar relative rounded-md shadow-light"
          >
            <FontAwesomeIcon className={classes.searchIcon} icon={faSearch} />
            <TextField
              onChange={e => handleSearch(e.target.value)}
              name="search"
              className="w-full py-2 ltr:pl-8 rtl:pr-8"
              variant="underlined2"
              placeholder={formatMessage({ id: "search.placeholder" })}
              value={query}
            />
            {closeIcon && (
              <FontAwesomeIcon
                className={classes.closeIcon}
                icon={faTimesCircle}
                onClick={onSearchClose}
              />
            )}
          </div>
        </form>
      </div>

      <SearchSuggestions visible={Boolean(query)} data={results} />
    </div>
  );
};

const SearchSuggestions = ({ visible, data }) => {
  const { locale } = useIntl();

  return (
    <div
      dir={locale === "ar" ? "rtl" : "ltr"}
      style={{
        boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.15)",
        maxHeight: "18.3rem",
        overflowY: "scroll",
      }}
      className={classNames(
        "absolute mt-3 w-full top-full bg-white rounded-lg px-3",
        visible ? "visible" : "hidden"
      )}
    >
      {!data.length && (
        <div className="py-4">
          <FormattedMessage id="search.notFound" />
        </div>
      )}

      {data.map(() => (
        <a
          href="#test"
          className="search-item block py-4 border-b border-gray-200 last:border-none"
        >
          Example of search result
        </a>
      ))}
    </div>
  );
};

export default Search;
